export default "__VITE_ASSET__CBDw4UJy__"